import { cn, Tooltip, TooltipArrow, TooltipContent, TooltipPortal, TooltipTrigger } from "@teamworksdev/react";
import type { ComponentProps, PropsWithChildren, ReactNode } from "react";

type WithTooltipProps = PropsWithChildren<{
  asChild?: boolean;
  defaultOpen?: boolean;
  disabled?: boolean;
  subtext?: string;
  title?: string;
  tooltipContent?: ReactNode;
  tooltipContentProps?: ComponentProps<typeof TooltipContent>;
  triggerProps?: ComponentProps<typeof TooltipTrigger>;
}>;

export const WithTooltip = ({
  asChild,
  children,
  disabled,
  subtext,
  title,
  tooltipContent,
  tooltipContentProps,
  triggerProps,
}: WithTooltipProps) => {
  const content = tooltipContent || <DefaultTooltipContent title={title} subtext={subtext} />;

  return (
    <Tooltip>
      <TooltipTrigger asChild={asChild} onClick={(e) => e.preventDefault()} {...triggerProps}>
        {children}
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          className={cn("p-2", {
            hidden: disabled,
          })}
          onPointerDownOutside={(e) => e.preventDefault()}
          {...tooltipContentProps}
        >
          <div className="max-w-[300px]">{content}</div>
          <TooltipArrow />
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
};

type DefaultTooltipContentProps = {
  title?: string;
  subtext?: string;
};

const DefaultTooltipContent = ({ title, subtext }: DefaultTooltipContentProps) => {
  return (
    <>
      <p className="font-semibold">{title}</p>
      {subtext && <p className="opacity-60 mt-1">{subtext}</p>}
    </>
  );
};
